module.exports = __webpack_public_path__ + "img/phone-entryUA.836cd0a1.png";